import { last } from "@/utils/helper";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { useState } from "react";

const WaitingForDeserving = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const onItemClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div className="text-center m-0 py-12 px-4 md:py-20 md:px-10">
      <h2 className="text-black text-4xl mb-8 md:text-6xl font-medium xl:mb-7 w-1/2 mx-auto">
        <span className="inline-block">Check out Opportunities</span>
      </h2>
      <p className="font-medium text-lg md:text-xl text-gray-500 text-opacity-70">
        <span>
          ultroNeous is always in search of talents who are ready to evolve,
          expand and enhance the knowledge.
        </span>
      </p>
      <p className="font-medium text-lg md:text-xl text-gray-500 text-opacity-70">
        <span>
          If you are ready to push your limits and reach new heights, we are the
          place for you.
        </span>
      </p>
      <div className="w-full xl:w-3/4 2xl:w-3/5 my-12 md:my-36 mx-auto">
        {data.data2.technology.map((element, index) => (
          <div key={element.departmentName}>
              <div className="mb-0 my-4">
                <div
                  className="text-left lg:pt-4 pb-3 px-5 md:mx-4 flex justify-between items-center h-16 md:h-24 cursor-pointer"
                  onClick={() => onItemClick(index)}
                >
                  <h4
                    className={`font-medium text-lg md:text-3xl flex items-center ${
                      index === activeIndex
                        ? "text-primary-yellow"
                        : "text-black/50"
                    }`}
                  >
                    <span>
                      {element.departmentName}
                      <span className="ps-2 ml-2">
                        ({element.technology.length})
                      </span>
                    </span>
                  </h4>
                  <span className="flex">
                    {index === activeIndex ? (
                      <Image
                        src={"/assets/common/minus.webp"}
                        width={20}
                        height={4}
                        alt="minus"
                      />
                    ) : (
                      <Image
                        src={"/assets/common/plus.webp"}
                        width={20}
                        height={20}
                        alt="plus"
                      />
                    )}
                  </span>
                </div>
                <div
                  className={`text-base md:ml-4 text-justify pt-0 md:pt-4 pl-5 pr-5 md:pr-10 pb-6 md:pb-10 text-black ${
                    index === activeIndex
                      ? "block transition-all ease-in duration-500"
                      : "hidden transition-all ease-out duration-500"
                  }`}
                >
                  {element.technology.map((value) => (
                    <a
                      key={value.technologyName}
                      href={`mailto:hr@ultroneous.com?subject=Applying for: ${value.technologyName}`}
                      className="w-full"
                    >
                      <div className="flex justify-between cursor-pointer items-center w-full my-4">
                        <p className="text-start text-black hover:ml-2 transition-all duration-500 hover:ease-in ease-out w-11/12 my-4">
                          <span>
                            {value.technologyName}
                            <span className="text-center text-xs ml-3 rounded-full text-white px-2 py-0.5 inline-flex justify-center items-center aspect-square bg-black/70">
                              {value.count}
                            </span>
                          </span>
                        </p>
                        <p className="text-black">
                          <FontAwesomeIcon
                            icon={faChevronRight}
                            width={"0.5rem"}
                          />
                        </p>
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            {index === last(data.data2.technology) ? undefined : (
              <hr className="h-0.5 my-4" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WaitingForDeserving;
